export default __webpack_public_path__ + "static/media/12.67ac81fd.png";